<template>
	<div>
		<div class="list-group-item user-account-title p-l-30" @click="toggleUsersView"
			:class="{ 'user-account-title-open': showUsers }">
			<span class="acc-name">{{ accountDisplay }}</span>
			<span class="label label-outline user-count">{{ userCountDisplay }}</span>
			<span class="label" :class="environmentDisplayClass" v-html="industryDecode"></span>
			<span v-show="hasPendingApproval" class="label label-warning approval-warning" v-cloak>Waiting
				Approval</span>
			<account-preferences :account_nbr="account_nbr" :account_display_nm="accountDisplay"
				:industry_list="industry_list" :current_industry_id="account_industry_id" @setIndustry="setIndustry"
				:sample-freq-map="sampleFreqMap"></account-preferences>
		</div>
		<div>
			<div class="list-group-item" v-show="showUsers" @click.stop="">
				<admin-user-role-list v-for="(user, index) in users" :user_id="user.user_id"
					:first_nm="user.user.first_nm" :last_nm="user.user.last_nm" :company_nm="user.user.company_nm"
					:account_nbr="account_nbr" :status_cd="user.user.status_cd" :is_locked="user.user.is_locked"
					:last_login_ts="user.user.last_login_ts" :has_pending_approval="user.user.has_pending_approval"
					:email="user.user.email" :phone1="user.user.phone1" :city="user.user.city"
					:state_cd="user.user.state_cd" :roles_array="user.rolesArray" :all_roles="all_roles"
					:visible_user_is_sys_admin="visible_user_is_sys_admin" :visible_user_id="visible_user_id"
					:actor_is_auth_ad_on_this_account="actorIsAuthAdOnThisAccount"
					:sole_admin_self="visible_user_id === user.user_id && approvedAdminCountOnAccount === 1"
					@updateUserData="updateUserData(index, $event)"></admin-user-role-list>

				<!-- row add user-->
				<div class="row">
					<div class="col-lg-3">
						<div class="form-group ">
							<label for="addUserEmail">User Email</label>
							<span class="fg-line">
								<input id="addUserEmail" class="form-control" name="addUserEmail"
									v-model="add_user_email" v-on:keyup.enter="addUser" type="text">
							</span>
							<span v-if="error" class="simple-error">{{ error }}</span>
							<span v-else="!error" class="help-block">Add a user to this account</span>
						</div>
					</div>
					<div class="col-lg-6">
						<button class="btn add-btn" type="button" @click="addUser"><span class="fa fa-plus"></span>
							&nbsp;Add User
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style lang="scss">
@import '../../sass/_global_variables.scss';

.user-account-title-open {
	background-color: darken(#e8e8e8, 5%) !important;
}

.user-account-title {

	.acc-name {
		font-size: 15px;
		font-weight: 700;
	}

	.user-count {
		text-transform: uppercase;
		margin-left: 5px;
		font-size: 12px;
	}

	.approval-warning {
		float: right;
		text-transform: uppercase;
		margin-left: 5px;
		margin-top: 3px;

	}

}
</style>

<script>
module.exports = {
	props: [
		'index',
		'account_nbr',
		'account_nm',
		'city',
		'state_cd',
		'users',
		'all_roles',
		'total_accounts',
		'account_industry_id',
		'industry_list',
		'visible_user_is_sys_admin',
		'visible_user_id',
		'sampleFreqMap',
	],

	data: function () {
		return {
			showUsers: false,
			add_user_email: "",
			hasPendingApproval: false,
			error: "",
		}
	},
	computed: {
		userCountDisplay: function () {
			if (!this.users) {
				return '0 Users';
			} else if (this.users.length == 1) {
				return '1 User'
			} else {
				return this.users.length + ' Users'
			}
		},

		accountDisplay: function () {
			return "#" + this.account_nbr + " - " + this.account_nm + " (" + this.city + ", " + this.state_cd + ")";
		},

		industryDecode: function () {

			var pos = (this.industry_list.map(function (a) {
				return a.industry_id
			}).indexOf(this.account_industry_id))

			if (pos != -1) {
				return this.industry_list[pos].industry_nm;
			}

			return ""

		},

		environmentDisplayClass: function () {
			var displayClass = "industry-" + this.industryDecode.substring(0, 3).toLowerCase();
			return displayClass;
		},

		actorRolesOnThisAccount() {
			const me = (this.users || []).find(u => u.user_id === this.visible_user_id);
			return me && me.rolesArray ? me.rolesArray : {};
		},

		actorIsAuthAdOnThisAccount() {
			const r = this.actorRolesOnThisAccount;
			return r.hasOwnProperty('AUTH_AD') && (r['AUTH_AD'] === 0 || r['AUTH_AD'] === 1);
		},

		approvedAdminCountOnAccount() {
			return (this.users || []).filter(u => u.rolesArray && u.rolesArray['ACT_ADM'] === 0).length;
		},
	},
	methods: {

		validateEmail: function (email) {
			var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		},

		toggleUsersView: function () {
			if (this.total_accounts > 1) {
				this.showUsers = !this.showUsers;
			}
		},

		setIndustry: function (industry) {
			this.$emit('set-industry', this.index, industry);
		},

		updateUserData: function (user_index, newRolesArray) {
			Vue.set(this.users[user_index], 'has_pending_approval', false);
			this.setPendingApproval();
			this.users[user_index].rolesArray = newRolesArray;
		},

		setPendingApproval: function () {
			var returnValue = false;
			if (this.users) {
				for (var i = 0; i < this.users.length; i++) {
					if (this.users[i].has_pending_approval) {
						returnValue = true;
					}
				}
			}
			this.hasPendingApproval = returnValue;
		},
		emailInList: function (checkEmail) {
			for (var i = 0; i < this.users.length; i++) {
				if (this.users[i].user.email == checkEmail) {
					return true;
				}
			}
			return false;
		},
		addUser: function () {
			this.error = '';
			this.add_user_email = this.add_user_email.trim();
			if (!this.validateEmail(this.add_user_email)) {
				this.error = 'The e-mail you entered is invalid';
			} else if (this.emailInList(this.add_user_email)) {
				this.error = 'The e-mail is already listed for this account'
			} else {

				var newUser = {
					user: { 'email': this.add_user_email },
					rolesArray: {},
					account_nbr: this.account_nbr
				};

				this.users.push(newUser);
				this.add_user_email = "";
			}
		},
	},


	mounted: function () {
		this.setPendingApproval();
		if (this.total_accounts == 1) {
			this.showUsers = true;
		}
	}
}

</script>



// WEBPACK FOOTER //
// admin-account-list-item.vue?7c4c0c5e